import { keyframes } from 'styled-components';

export const gemAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10%);
  }
  100% {
    transform: translateY(0);
  }
`;

export const reversedGemAnimation = keyframes`
  0% {
    transform: translateY(10%);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10%);
  }
`;
